<template lang="pug">
//- .new-order-done-popup.d-flex.justify-content-center.align-items-center
  //- .backdrop
.text-center.p-5
  .text-center.mb-5: img.img-128(src="@/assets/icons/bill.png")
  .px-5
    p.h4
      | {{ title }}
    p.text-secondary.my-5
      | {{ message }}
    template(v-if='isQuotation === false')
      a.btn.btn-upa-secondary.mb-2(
        href="#"
        @click="downloadFile")
        | ดูเอกสาร PDF
    br
    button.btn.btn-secondary(style="min-width: 240px;" @click="$router.push('/sales')")
      | กลับหน้าแรก
</template>

<script>
export default {
  props: {
    isQuotation: { default: false },
    orderId: {},
  },
  computed: {
    title() {
      if (this.isQuotation) {
        return 'คุณเสร็จสิ้นการเปิดใบเสนอราคา';
      }
      return 'คุณเสร็จสิ้นการเปิดการขาย';
    },
    message() {
      if (this.isQuotation) {
        return 'คุณสามารถดูใบเสนอราคานี้ได้ที่เมนู "ประวัติการขาย" เลือกลูกค้า แล้วเลือกที่ "ดูรายการใบเสนอราคา';
      }
      return 'คุณทำรายการสั่งซื้อสำเร็จ ขณะนี้รายการของท่านอยู่ระหว่างขั้นตอนการอนุมัติ ท่านสามารถบันทึกไฟล์รายการขายได้โดยกดปุ่มทำรายการด้านล่าง';
    },
  },
  methods: {
    async downloadFile() {
      const url = await this.$api.order.getReportURL(this.orderId);
      window.open(url);
    },
  },
};
</script>

<style lang="scss">
// .new-order-done-popup {
//   position: fixed; top: 0; right: 0; left: 0; bottom: 0;
//   padding: 24px;
//   z-index: 20;
//   .backdrop {
//     position: absolute; top: 0; right: 0; left: 0; bottom: 0;
//   }
//   .popup-card {
//     width: 100%;
//     min-width: 480px;
//     max-width: 640px;
//   }
// }
</style>
